
import EditComponent from "../../../components/mall_coupons/Edit.vue";

export default {
  components: {
    EditComponent,
  },
};
